const truncatePointsToTwoDecimals = (points: string) => {
  const [whole, decimals = ""] = points.split(".");
  return `${whole}.${(decimals + "00").slice(0, 2)}`;
};

export default truncatePointsToTwoDecimals;
